/* eslint-disable react-hooks/exhaustive-deps */
import { Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { getPopupContainer } from '../../../../../../helpers/popUp';

export default function DropdownIndicator({
  filters,
  onFilterChange,
  t = (s) => s,
  doPopOver = true,
}) {
  const defaultValue = useMemo(() => {
    if (filters && filters.settings) {
      const set = filters.settings;
      if (set.default) {
        return set.default;
      }
      if (set.options && set.options[0] && set.options[0].value) {
        return set.options[0].value;
      }
    }
    return null
  }, [filters]);
  const [selectValue, setSelectValue] = useState(defaultValue);

  const outActions = {
    resetValue: () => setSelectValue(defaultValue),
  };

  useEffect(() => {
    if (filters.onInit) {
      filters.onInit(outActions);
    }
  }, []);

  return (
    <Select
      {...getPopupContainer()}
      size="small"
      value={selectValue}
      className="custom-select"
      defaultValue={defaultValue}
      onChange={(val) => {
        onFilterChange(val);
        setSelectValue(val);
      }}
      style={{ width: 150 }}>
      {(filters.settings.options || []).map(option => (
        <Select.Option key={option.value} value={option.value}>
          {t(option.label)}
        </Select.Option>
      ))}
    </Select>
  );
}
